import Loader from "components/shared/Loader";
import React, { useEffect, useMemo, useState } from "react";
import Debounce from "utilities/Debounce";
import useApp from "hooks/useApp";
import { FiChevronDown, FiChevronRight, FiCopy } from "react-icons/fi";
import classNames from "utilities/ClassNames";
import OrganizationHeader from 'components/organization/OrganizationHeader';
import OrganizationTabs from 'components/organization/OrganizationTabs';
import OrganizationActionMenu from "components/organization/OrganizationActionMenu";
import ConfirmationModal from "components/Modal/ConfirmationModal";
import { removeOrganization } from "api/organizations";
import ProjectReassignModal from "components/Modal/ProjectReassignModal";
import { demoOrganizationsMockData } from "@/lib/constants";
import UsersTable from "components/organization/UsersTable";
import { getAllOrganizations, getAllOrganizationUsers, getAllUsersWithOrganization } from "api/users";
import { getProfileSolutions } from "api/solutions";



export default function OrganizationAndUsersContainer({ type }: { type: string }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [organizations, setOrganizations] = useState<any>([]);
  const [expandedOrg, setExpandedOrg] = useState<number | null>(null);
  const { isScaled } = useApp();
  const [activeTab, setActiveTab] = useState(type === "superadmin" ? 'organizations' : 'users');
  const [refreshMode, setRefreshMode] = useState('');
  const [editOrg, setEditOrg] = useState<any>(null);
  const [deleteOrg, setDeleteOrg] = useState<any>(null);
  const [selectedUser, setSelectedUser] = useState<any>(null);

  const [users, setUsers] = useState<any>([]);
  const [orgUsers, setOrgUsers] = useState<any>([]);
  const [projects, setProjects] = useState<any>([]);
  const [keyword, setKeyword] = useState("");
  const [debouncedKeyword, setDebouncedKeyword] = useState("");
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingProjects, setLoadingProjects] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [orgUserSearchQuery, setOrgUserSearchQuery] = useState('');
  const [copyNotification, setCopyNotification] = useState<string | null>(null);
  const [showNotification, setShowNotification] = useState(false);
  const [organizationFilters, setOrganizationFilters] = useState({
    status: [],
    date: null,
  });

  Debounce(() => setDebouncedKeyword(keyword), [keyword], 500);


  const getUsersWithOrganization = async () => {
    try {
      setLoading(true);
      setLoadingUsers(true);
      const usersLists: any = await getAllUsersWithOrganization();
      console.log("usersLists"  ,usersLists);
      const organizationsLists: any = await getAllOrganizations();
      if (usersLists.status === 200) {
        if (usersLists.data.list.length > 0) {
          setUsers(usersLists.data.list);
        }
      }
      if (organizationsLists.status === 200) {
        if (organizationsLists.data.list.length > 0) {
          setOrganizations(organizationsLists.data.list);
        }
      }
      setLoading(false);
      setLoadingUsers(false);
    } catch (error) {
      setLoading(false);
      setLoadingUsers(false);
    }
  };

  const getAllProjects = async () => {
    try {
      setLoadingProjects(true);
      // Get projects for all organizations
      const allProjects: any[] = [];
      
      if (organizations.length === 0) {
        // Add sample data for demonstration
        const sampleProjects = [
          {
            id: '1',
            name: 'Test Project',
            desc: 'imply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text',
            location: 'Riyadh, Saudi Arabia',
            coordinates: null,
            audience: 'Public',
            category: 'Progress Monitoring',
            productId: '1',
            url: '',
            createdAt: '2024-06-10',
            organizationId: '1',
            organizationName: 'Sample Org',
            owner: 'Alex'
          },
                     {
             id: '2',
             name: 'ABC Test',
             desc: 'imply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever s',
             location: 'Jeddah, Saudi Arabia',
             coordinates: null,
             audience: 'Private',
             category: 'Progress Monitoring',
             productId: '1',
             url: '',
             createdAt: '2024-05-06',
             organizationId: '1',
             organizationName: 'Sample Org',
             owner: 'Nishad'
           },
           {
             id: '3',
             name: 'Project Alpha',
             desc: 'imply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text',
             location: 'Dammam, Saudi Arabia',
             coordinates: null,
             audience: 'Public',
             category: 'Progress Monitoring',
             productId: '1',
             url: '',
             createdAt: '2024-04-15',
             organizationId: '1',
             organizationName: 'Sample Org',
             owner: 'Sarah'
           }
        ];
        setProjects(sampleProjects);
        setLoadingProjects(false);
        return;
      }
      
      for (const org of organizations) {
        try {
          const response = await getProfileSolutions(org.id);
          if (response.status === 200 && response.data.list && response.data.list.length > 0) {
            const orgProjects = response.data.list.map((project: any) => ({
              ...project,
              organizationId: org.id,
              organizationName: org.name,
              owner: 'Alex' // Add default owner for now
            }));
            allProjects.push(...orgProjects);
          }
        } catch (error) {
          console.error(`Error fetching projects for organization ${org.id}:`, error);
        }
      }
      
      setProjects(allProjects);
      setLoadingProjects(false);
    } catch (error) {
      console.error('Error fetching projects:', error);
      setLoadingProjects(false);
    }
  };

  const onRefreshProjects = () => {
    getAllProjects();
  };

  const getOrganizationUsers = async (id: any) => {
    try {
      setLoadingUsers(true);
      const organizationUsersLists: any = await getAllOrganizationUsers(id);
      if (organizationUsersLists.status === 200) {
        if (organizationUsersLists.data.list.length > 0) {
          setOrgUsers(organizationUsersLists.data.list);
        }
      }
      setLoadingUsers(false);
    } catch (error) {
      setLoadingUsers(false);
    }
  };



  useEffect(() => {
    getUsersWithOrganization();
  }, []);

  useEffect(() => {
    if (refreshMode === 'organizations') {
      getUsersWithOrganization();
    }
  }, [refreshMode]);

  useEffect(() => {
    if (organizations.length > 0) {
      getAllProjects();
    }
  }, [organizations]);

  const handleRoleChange = (userId: string, newRole: string) => {
    setUsers((prevUsers: any) =>
      prevUsers.map((user: any) =>
        user.id === userId
          ? { ...user, userType: newRole }
          : user
      )
    );
  };

  const [userFilters, setUserFilters] = useState({
    organization: '',
    status: '',
    paymentStatus: '',
    paymentMethod: '',
    subscriptionType: '',
    userType: '',
    search: ''
  });

  const [projectFilters, setProjectFilters] = useState({
    duration: '',
    subscription: '',
    billingPeriod: '',
    paymentStatus: '',
    startDate: null,
    endDate: null,
    search: ''
  });

  const filteredOrganizations = useMemo(() => {
    let filtered = [...organizations];

    // Apply search filter
    if (searchQuery) {
      filtered = filtered.filter(org =>
        org.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Apply status filter
    if (organizationFilters.status.length > 0) {
      filtered = filtered.filter((org) =>
        organizationFilters.status.includes(org.status as never)
      );
    }

    // Apply date filter
    if (organizationFilters.date) {
      filtered = filtered.filter(org => {
        const orgDate = new Date(org.createdAt);
        const filterDate = new Date(organizationFilters.date as never);
        return orgDate.toDateString() === filterDate.toDateString();
      });
    }

    return filtered;
  }, [searchQuery, organizationFilters, organizations]);

  const handleDelete = async () => {
    if (deleteOrg) {
      try {
        await removeOrganization(deleteOrg);
        setRefreshMode('organizations');
        setOrganizations(organizations.filter((org: any) => org.id !== deleteOrg.id));
      } catch (error) {
        console.error('Error deleting organization:', error);
      }
      setDeleteOrg(null);
    }
  };

  // Auto-hide copy notification
  useEffect(() => {
    if (copyNotification) {
      setShowNotification(true);
      const timer = setTimeout(() => {
        setShowNotification(false);
        setTimeout(() => setCopyNotification(null), 300); // Wait for animation to complete
      }, 3000); // Increased to 3 seconds for better visibility
      return () => clearTimeout(timer);
    }
  }, [copyNotification]);

  return (
    <>
      {loading && (
        <div className="w-full h-[80vh] grid place-content-center">
          <Loader />
        </div>
      )}
      {error && (
        <div className="w-full h-[80vh] grid place-content-center">
          <p>Error loading data</p>
        </div>
      )}
      
      {/* Copy Notification */}
      {copyNotification && (
        <div className={`fixed top-6 right-6 bg-gradient-to-r from-emerald-500 to-green-500 text-white px-6 py-3 rounded-xl shadow-2xl z-[9999] border-2 border-emerald-400/30 backdrop-blur-sm transition-all duration-300 transform ${
          showNotification ? 'translate-x-0 opacity-100 scale-100' : 'translate-x-full opacity-0 scale-95'
        }`}>
          <div className="flex items-center gap-3">
            <div className="w-3 h-3 bg-white rounded-full animate-pulse shadow-lg"></div>
            <span className="font-semibold text-sm text-white drop-shadow-sm">{copyNotification}</span>
            <div className="w-2 h-2 bg-emerald-300 rounded-full animate-bounce"></div>
          </div>
        </div>
      )}
      
      {!loading && !error && organizations && (
        <div className={classNames(
          isScaled ? "text-base" : "text-base",
          "px-6 pb-3 overflow-hidden overflow-y-auto h-full"
        )}>
          <div className="pt-6 mb-6">
            <OrganizationHeader type={type} />
          </div>

          <div className="flex justify-between items-center">
            <h1 className="text-xl font-semibold text-white">{type === "superadmin" ? "Organizations & Users" : "Users & Projects"}</h1>
          </div>

          <OrganizationTabs
            type={type}
            activeTab={activeTab}
            onTabChange={setActiveTab}
            setRefreshMode={setRefreshMode}
            setOrgFilters={setOrganizationFilters}
            setUserFilters={setUserFilters}
            setProjectFilters={setProjectFilters}
            orgFilters={organizationFilters}
            userFilters={userFilters}
            projectFilters={projectFilters}
            users={users}
            projects={projects}
            handleRoleChange={handleRoleChange}
            loadingUsers={loadingUsers}
            loadingProjects={loadingProjects}
            onRefreshProjects={onRefreshProjects}
            onRefreshUsers={getUsersWithOrganization}
          >

            {activeTab === 'organizations' ? (
              <>
                <div className="sticky top-[130px] bg-black z-10 pt-4">
                  <div className="bg-[#2A2A2A] rounded-lg overflow-hidden">
                    <table className='w-full'>
                      <thead className=" ">
                        <tr className="bg-[#1A1A1A] text-gray-400 text-sm">
                          <th className="text-left py-3 px-4">Organization</th>
                          <th className="text-left py-3 px-4">Subscription</th>
                          <th className="text-left py-3 px-4">Users</th>
                          <th className="text-left py-3 px-4">Created By</th>
                          <th className="text-left py-3 px-4">Created Date</th>
                          <th className="text-right py-3 px-4">No. of Projects</th>
                          <th className="text-right py-3 px-4">Actions</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>


                <div className="bg-[#2A2A2A] rounded-lg overflow-hidden">
                  <div className="">
                    <table className="w-full ">

                      <tbody>
                        {
                          loading ? (
                            <tr>
                              <td colSpan={7} className="text-center text-gray-400 p-4">
                                <div className="flex items-center justify-center space-x-2">
                                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                  <span>Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            filteredOrganizations?.map((org: any) => (
                              <React.Fragment key={org.id}>
                                <tr
                                  className={`border-b border-white/[0.08]  cursor-pointer ${
                                    expandedOrg === org.id ? 'bg-[#cccccc33]' : ' hover:bg-[#3a3a3a33] '
                                  }`}
                                  onClick={() => {
                                    getOrganizationUsers(org.id);
                                    setExpandedOrg(expandedOrg === org.id ? null : org.id);
                                    setOrgUserSearchQuery(''); // Clear search when expanding
                                  }}
                                >
                                  <td className="py-3 px-4">
                                    <div className="flex items-center gap-2">
                                      {expandedOrg === org.id ? (
                                        <FiChevronDown className="text-gray-400" />
                                      ) : (
                                        <FiChevronRight className="text-gray-400" />
                                      )}
                                      <span className="text-white">{org.name}</span>
                                    </div>
                                  </td>
                                  <td className="py-3 px-4 text-gray-400">{org?.subscriptionType}</td>
                                  <td className="py-3 px-4 text-gray-400">{org?.users?.length}</td>
                                  <td className="py-3 px-4 text-gray-400">{org?.createdBy}</td>
                                  <td className="py-3 px-4 text-gray-400">{org?.createdDate}</td>
                                   <td className="py-3 px-4 text-right text-gray-400">{org.projectCount}</td>
                                  <td className="py-3 px-4 text-right">
                                    <OrganizationActionMenu
                                      organization={org}
                                      onEdit={(org) => setEditOrg(org)}
                                      onDelete={(org) => setDeleteOrg(org)}
                                    />
                                  </td>
                                </tr>

                                {/* Users expanded view */}
                                {expandedOrg === org.id && (
                                  <>
                                    {/* Users Header Row */}
                                    <tr className="border-b border-white/[0.08] bg-[#000]">
                                      <td colSpan={7} className="p-4">
                                        <div className="flex items-center justify-between">
                                          <input 
                                            type="text" 
                                            placeholder="Search users..." 
                                            className="w-[200px] bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white" 
                                            value={orgUserSearchQuery}
                                            onChange={(e) => setOrgUserSearchQuery(e.target.value)}
                                            onClick={(e) => e.stopPropagation()}
                                          />
                                          <button 
                                            className="flex items-center gap-2 text-green-400 hover:text-green-300 transition-colors"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              // Add user mapping functionality here if needed
                                            }}
                                          >
                                            <span className="text-sm">+ Add User</span>
                                          </button>
                                        </div>
                                      </td>
                                    </tr>

                                    {/* Users Sub-table */}
                                    <tr className="bg-[#000]">
                                      <td colSpan={7} className="p-0">
                                        <div className="bg-[#000]">
                                          <table className="w-full">
                                            <thead>
                                              <tr className="bg-[#2A2A2A] text-gray-400 text-sm">
                                                <th className="text-left p-4 w-[25%]">Name</th>
                                                <th className="text-left p-4 w-[20%]">Email</th>
                                                <th className="text-left p-4 w-[15%]">Role</th>
                                                <th className="text-left p-4 w-[15%]">No of Projects</th>
                                                <th className="text-left p-4 w-[15%]">Projects</th>
                                                <th className="text-right p-4 w-[10%]">Actions</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {loadingUsers ? (
                                                <tr>
                                                  <td colSpan={6} className="p-4 text-center text-gray-400">
                                                    <div className="flex items-center justify-center space-x-2">
                                                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                                      <span>Loading users...</span>
                                                    </div>
                                                  </td>
                                                </tr>
                                              ) : orgUsers && orgUsers.filter((user: any) => 
                                                  user.name?.toLowerCase().includes(orgUserSearchQuery.toLowerCase()) ||
                                                  user.email?.toLowerCase().includes(orgUserSearchQuery.toLowerCase())
                                                ).length > 0 ? (
                                                orgUsers.filter((user: any) => 
                                                  user.name?.toLowerCase().includes(orgUserSearchQuery.toLowerCase()) ||
                                                  user.email?.toLowerCase().includes(orgUserSearchQuery.toLowerCase())
                                                ).map((user: any) => (
                                                  <tr key={user.id} className="border-b border-white/[0.08] hover:bg-[#3a3a3a33]">
                                                    <td className="p-4 w-[25%] text-white">
                                                      <div className="flex items-center gap-2">
                                                        <span>{user.name}</span>
                                                        <FiCopy 
                                                          className="text-gray-400 cursor-pointer hover:text-gray-300 transition-colors"
                                                          title="Copy User ID"
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                            navigator.clipboard.writeText(user.id);
                                                            setCopyNotification('User ID copied to clipboard!');
                                                          }}
                                                        />
                                                      </div>
                                                    </td>
                                                    <td className="p-4 w-[20%] text-gray-400">{user.email || "N/A"}</td>
                                                    <td className="p-4 w-[15%] text-gray-400">{user.role || "N/A"}</td>
                                                    <td className="p-4 w-[15%] text-gray-400">{user.projectCount || 0}</td>
                                                    <td className="p-4 w-[15%]">
                                                      <div className="flex gap-2 flex-wrap">
                                                        {user?.projects?.map((project: any, index: number) => (
                                                          <button
                                                            key={index}
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              setSelectedUser(user);
                                                            }}
                                                            className="text-blue-400 underline hover:text-blue-300 text-sm"
                                                          >
                                                            {project.name}
                                                          </button>
                                                        )) || "No projects"}
                                                      </div>
                                                    </td>
                                                    <td className="p-4 text-right w-[10%]">
                                                      <button 
                                                        className="text-gray-400 hover:text-white transition-colors"
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          setSelectedUser(user);
                                                        }}
                                                      >
                                                        Edit
                                                      </button>
                                                    </td>
                                                  </tr>
                                                ))
                                              ) : (
                                                <tr>
                                                  <td colSpan={6} className="p-4 text-center text-gray-400">
                                                    {orgUsers && orgUsers.length === 0 
                                                      ? "No users found for this organization" 
                                                      : "No users match your search"}
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                )}
                              </React.Fragment>
                            ))
                          )
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            ) : (
              <UsersTable filters={userFilters} users={users} handleRoleChange={handleRoleChange}
                loadingUsers={loadingUsers}
              />
            )}
          </OrganizationTabs>

        </div>
      )}

      <ConfirmationModal
        isOpen={!!deleteOrg}
        message="Are you sure you want to delete this organization?"
        onConfirm={handleDelete}
        onCancel={() => setDeleteOrg(null)}
      />

      <ProjectReassignModal
        isOpen={!!selectedUser}
        onClose={() => setSelectedUser(null)}
        userData={demoOrganizationsMockData[0]?.users[0] as any}
        allUsers={demoOrganizationsMockData[0]?.users as any}
      />

    </>
  );
}
